<script>
export default {
  name: "KpiCard",
  props: {
    items: { type: Array, required: true },
    loaded: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },
  methods: {
    trendIcon(direction) {
      if (direction === 'up') return 'fa-solid fa-arrow-up';
      if (direction === 'down') return 'fa-solid fa-arrow-down';
      return 'fa-solid fa-minus';
    },
    trendClass(direction) {
      if (direction === 'up') return 'kpi-trend-up';
      if (direction === 'down') return 'kpi-trend-down';
      return 'kpi-trend-flat';
    }
  }
};
</script>

<template>
  <div class="kpi-content">
    <div
      v-if="error"
      class="fail-state"
    >
      <i class="fa-solid fa-triangle-exclamation text-amber-400" />
      <p>Unable to load</p>
    </div>
    <template v-else-if="!loaded">
      <div
        v-for="i in 4"
        :key="i"
        class="kpi-row"
      >
        <div class="skel skel-label" />
        <div class="skel skel-value" />
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item, idx) in items"
        :key="idx"
        class="kpi-row"
      >
        <div class="kpi-left">
          <span class="kpi-label">{{ item.label }}</span>
          <span
            v-if="item.trend"
            :class="['kpi-trend', trendClass(item.trend)]"
          >
            <i :class="trendIcon(item.trend)" />
          </span>
          <span
            v-else-if="item.sublabel"
            class="kpi-sub"
          >{{ item.sublabel }}</span>
        </div>
        <div class="kpi-value">
          {{ item.value }}
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.kpi-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.fail-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #9ca3af;
  font-size: 0.8rem;
  gap: 4px;
}

.kpi-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(8, 18, 37, 0.08);
  &:last-child { border-bottom: none; }
}

.kpi-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.kpi-label { font-size: 0.8rem; font-weight: 500; color: #374151; }
.kpi-value { font-size: 1rem; font-weight: 700; color: #1f2937; white-space: nowrap; }
.kpi-sub { font-size: 0.65rem; color: #9ca3af; }
.kpi-trend { font-size: 0.7rem; }
.kpi-trend-up { color: #10b981; }
.kpi-trend-down { color: #ef4444; }
.kpi-trend-flat { color: #9ca3af; }

.skel {
  height: 14px;
  background: #f3f4f6;
  border-radius: 4px;
  animation: shimmer 1.5s ease-in-out infinite;
}
.skel-label { width: 45%; }
.skel-value { width: 20%; }

@keyframes shimmer {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

//Print view adjustments
@media print {
  .kpi-row {
    display: flex !important;
    justify-content: space-between !important;
  }
  .kpi-left {
    display: flex !important;
    align-items: center !important;
  }
}
</style>
